<p-dialog
    header="Import Containers from Clipboard"
    [visible]="visible"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [style]="{ width: '90vw', height: '90vh' }"
    [contentStyle]="{ display: 'flex', flexDirection: 'column', overflow: 'hidden', height: '100%' }"
    [maximizable]="true"
    (onHide)="close()">

    <div class="flex flex-column gap-3" style="flex: 1; min-height: 0; overflow: hidden;">

        <div class="flex align-items-center gap-3" style="flex-shrink: 0;">
            <p-button
                label="Paste from Clipboard"
                icon="pi pi-clipboard"
                (onClick)="pasteFromClipboard()"/>
            <span *ngIf="parsedRows.length > 0" class="text-500 text-sm">
                {{ parsedRows.length }} rows · {{ columnCount }} columns detected
            </span>
        </div>

        <p-message *ngIf="errorMessage" severity="error" [text]="errorMessage"/>

        <ng-container *ngIf="parsedRows.length > 0">
            <div style="flex: 1; min-height: 0; overflow: hidden;">
                <p-table
                    [value]="parsedRows"
                    [scrollable]="true"
                    scrollHeight="flex"
                    styleClass="p-datatable-sm p-datatable-gridlines">

                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let colIndex of columnIndices" style="min-width: 220px; vertical-align: top;">
                                <p-select
                                    [options]="groupedOptions"
                                    [(ngModel)]="columnMappings[colIndex]"
                                    optionLabel="label"
                                    optionValue="value"
                                    [group]="true"
                                    placeholder="— Ignore —"
                                    [style]="{ width: '100%' }"
                                    appendTo="body"
                                >
                                    <ng-template pTemplate="group" let-group>
                                        <span class="font-semibold text-xs text-500 uppercase tracking-wide">
                                            {{ group.label }}
                                        </span>
                                    </ng-template>
                                </p-select>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td *ngFor="let colIndex of columnIndices" class="text-sm white-space-nowrap">
                                {{ row[colIndex] }}
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>
        </ng-container>

    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="close()"/>
        <p-button
            label="Import"
            icon="pi pi-check"
            [disabled]="parsedRows.length === 0"
            (onClick)="confirm()"/>
    </ng-template>
</p-dialog>
